import api from '../../../services/api';

export const MAX_COST_AMOUNT = 1000000000;
export const CUSTOMER_ORDER_COST_CATEGORY = 'OTHER';

function cloneFormData(source: FormData): FormData {
  const next = new FormData();

  source.forEach((value, key) => {
    next.append(key, value);
  });

  return next;
}

export interface SaveOrderCostInput {
  orderId: string;
  costId?: string;
  values: Record<string, any>;
}

export function isManualCustomerOrderCost(cost?: { category?: string; transportId?: string | null } | null): boolean {
  return cost?.category === CUSTOMER_ORDER_COST_CATEGORY && !cost.transportId;
}

export function isManagedTransportCost(cost?: { transportId?: string | null } | null): boolean {
  return Boolean(cost?.transportId);
}

function getUploadedFile(fileList?: any[]) {
  const file = fileList?.[0];
  return file?.originFileObj || file?.file || null;
}

function buildOrderCostFormData(values: Record<string, any>): FormData {
  const payload = new FormData();
  payload.append('category', CUSTOMER_ORDER_COST_CATEGORY);

  ['currency', 'amount', 'description'].forEach((key) => {
    if (values[key] !== undefined && values[key] !== null) {
      payload.append(key, values[key]);
    }
  });

  const uploadedFile = getUploadedFile(values.document);
  if (uploadedFile) {
    payload.append('document', uploadedFile);
  }

  return payload;
}

export async function saveOrderCost({ orderId, costId, values }: SaveOrderCostInput): Promise<void> {
  const payload = cloneFormData(buildOrderCostFormData(values));

  if (costId) {
    await api.put(`/costs/${costId}`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return;
  }

  payload.append('orderId', orderId);
  await api.post('/costs', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function deleteOrderCost(costId: string): Promise<void> {
  await api.delete(`/costs/${costId}`);
}
